import { colors } from 'styles/colors';
import { ThermalComfortVariant } from './components/UnitsInfo/types';
import { t } from 'i18next';

export function colorByThermalComfortVariant(variant: ThermalComfortVariant): string {
  switch (variant) {
    case 'comfortable': return colors.state.success.base;
    case 'regular': return colors.state.warning.base;
    case 'bad': return colors.state.danger.base;
    default: return colors.icon['soft-400'];
  }
}

export function hoverColorByThermalComfortVariant(variant: ThermalComfortVariant): string {
  switch (variant) {
    case 'comfortable': return colors.state.success.dark;
    case 'regular': return colors.state.warning.dark;
    case 'bad': return colors.state.danger.dark;
    default: return colors.icon['strong-800'];
  }
}

export function parseThermalComfortVariantLabel(variant: ThermalComfortVariant): string {
  switch (variant) {
    case 'comfortable': return t('confortoBom');
    case 'regular': return t('confortoRegular');
    case 'bad': return t('confortoRuim');
    default: return t('semConexao');
  }
}

export function canSeeDetailsButtonByValue(value: number | undefined): boolean {
  return (value ?? 0) > 0;
}
